import { useState, useEffect, useRef } from "react";

const useCamera = () => {
  const videoRef = useRef<HTMLVideoElement>(null); // Reference to the video element
  const [error, setError] = useState(null); // Error state
  const [isStreaming, setIsStreaming] = useState(false); // Camera streaming state

  useEffect(() => {
    // Cleanup on component unmount
    return () => {
      stopCamera();
    };
  }, []);

  const startCamera = async () => {
    try {
      setError(null); // Clear any previous error
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 640 }, // 期望640x640
          height: { ideal: 640 },
          aspectRatio: 1, // 强制 1:1 宽高比
          facingMode: "user", // 前置摄像头
        },
      });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
        setIsStreaming(true);
      }
    } catch (err: any) {
      console.error("Error accessing the camera:", err);
      setError(err.message || "Error accessing the camera.");
    }
  };

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      if (stream instanceof MediaStream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      videoRef.current.srcObject = null;
      setIsStreaming(false);
    }
  };

  return { videoRef, startCamera, stopCamera, error, isStreaming };
};

export default useCamera;
